export const partyPhrases = [
  "What’s the most embarrassing thing you’ve had to ask Google?",
  "When was the last time you laughed so hard you cried?",
  "Would you “take care” of a spider for me? What about a cockroach?",
  "What motto would you put on your family crest?",
  "Why do you put up with me?",
  "Describe a time you accidentally mortified your parents as a child.",
  "Tell me your favorite joke. If I laugh, I drink.",
  "If I could help you with one unpleasant task, what would it be?",
  "Fill in the blank. Defend yourself: I don't care if ______ is for kids, I will still love it until I die.",
  "Do you try to always be honest with me, or do you tell me that haircut looks great-level white lies to be nice?",
  "What’s the best joke you’ve ever come up with on the fly?",
  "What are the farthest lengths you’ve gone to cheer someone up?",
  "What’s the most courageous thing you’ve ever accomplished?",
  "Aside from “moist”, what word can’t you stand the sound of?",
  "What is your ideal name for a dog? A cat? Now pick any non-traditional pet and name it.",
  "What movie or TV character do I most remind you of?",
  "What song are you most ashamed to admit to me that you love? Reply in song.",
  "With what hilarious story about me do you regale people I do not know?",
  "Am I better or worse off when I am caffeinated?",
  "Name a dream of yours that you’ve made come true.",
  "What is your happiest memory from when you were a single-digit-aged child?",
  "When’s the exact moment you knew we were on the same wavelength?",
  "What’s a situation that is always improved by my presence?",
  "If you had synesthesia, what color would I make you feel?",
  "Who would play me in the Oscar-winning film about my life?",
  "How have I helped you the most?",
  "What’s the most considerate present you’ve ever received? Given?",
  "If dogs and their owners are supposed to have matching personalities, what type of dog should I get?",
  "What’s the title of your autobiography? Extra imaginary points if it includes a colon and a subtitle.",
  "What’s your favorite memory of our relationship?",
  "What movie or TV quote hits a little too close to home?",
  "Would you give me one of your kidneys?",
  "What snack do you find the most comfort in consuming?",
  "If you could have any body part of mine (for aesthetic, not medical, reasons), what would it be?",
  "What is something you love about me that other people don’t understand at all?",
  "If you could plan the perfect night with all of your friends, what would it entail?",
  "What positive impact do you think you have on other people?",
  "What would you entrust me with above anyone else?",
  "What board game are you positive you could destroy us all at?",
  "What’s something I’m self-conscious about that you think I should stop stressing out over?",
  "Describe the dream vacation you haven’t gotten to take. Then tell me how you can make it happen in five years or less.",
  "What’s your ultimate Sunday look like? Your ultimate sundae?",
  "What dish do you slay in the kitchen every time you make it?",
  "What are you rooting for me to achieve?",
  "What author’s body of work do you wish you were responsible for?",
  "If there were no barriers to entry, what job do you think you’d be amazing at?",
  "If you could instantly gain any skill, what would it be?",
  "Out of all of us, whose eyes would you like to see the world through for a day?",
  "On what topic could you be an expert TV talking head?",
  "Show me the funniest thing on the internet under 30 seconds long. If I laugh, I drink.",
  "We’re binging tonight! Pick the show and the snack.",
  "What song reminds you of me whenever you hear it?",
  "Would you ever see a band in concert that you hated just to make me happy? Have you?",
  "When do you think you peaked?",
  "If I were a perfume or cologne, what would my top, heart, and base notes be?",
  "Do you ever just let me win?",
  "What best represents me as a friend: a weighted blanket, a spin class, or a wine tasting?",
  "We’re starting a business. What venture would we be most successful at as a pair?",
  "What’s the most kickass you’ve ever felt?",
  "If we formed a gang, what would the name of our posse be?",
  "What’s the most fun you’ve ever had with strangers? Tell us the story.",
  "What do you wish you were as good as me?",
  "What is something you know you’ll accomplish, no matter how many people tell you you can’t?",
  "If someone did me wrong, would you (a) comfort me, (b) distract me, or (c) get revenge for me?",
  "What makes you so much fun?",
  "If you could live anyone else’s life, whose would it be?",
  "How many seconds is the ideal hug? Should we all test your hypothesis?",
  "What is the most comforting sound in the world?",
  "Describe an act of petty protest you waged at work or school.",
  "What’s one thing you can start doing to put more beauty back into the world?",
  "What’s something that completely changed you when you encountered it for the first time?",
  "Do you ever pity-laugh at my jokes, even if you don’t think they’re funny?",
  "What discontinued item would you give anything to bring back?",
  "Would you trust me to pierce your ear, 80’s-sleepover style?",
  "I’m going to have permanent art deposited into my skin with needles. Pick a design for me. Bonus points if you draw it.",
  "What’s the biggest fear you’ve overcome?",
  "What smell takes you back to childhood?",
  "Do you brag about me to other people? What do you say?",
  "You suddenly become wealthy beyond the dreams of avarice. What do you do with the rest of your life?",
  "What’s the weirdest compliment you’ve ever gotten?",
  "What would be your cheesy, 20-second, game-show-contestant anecdote?",
  "If I couldn’t reach an itch, would you do me a solid and scratch it?",
  "What’s guaranteed to hit you right in the feels?",
  "If you were a Care Bear, what would be on your belly?",
  "We’re road-tripping through the middle of nowhere. Do you have me drive or navigate?",
  "What was your first impression of me? Has it turned out to be the case?",
  "What’s the hold music for your brain?",
  "Liking what piece of pop culture gets someone your automatic stamp of approval?",
  "What’s the strangest nickname you’ve ever been given?",
  "Of all the things we do together, what is the best thing we do together?",
  "You get to travel back in time to warn me about one thing. What would it be?",
  "If we were flying somewhere together, who would volunteer to sit in the middle seat?",
  "What did you think you would hate, but ended up loving?",
  "What album have you spun the most times? Be honest. You can consult your music apps for verification.",
  "What do you secretly think I’d be amazing at?",
  "Who here is most likely to believe in supernatural, occult, or mystical stuff?",
  "Tell me about a disagreement we had—and how we resolved it. Has it made us stronger?",
  "What is your greatest style-related regret as an adult?",
  "List all the illicit drugs you’ve tried. What more would you like to try?",
  "How confident are you in your oral sex skills? How do you know?",
  "Give us a passionate example of your dirty talk.",
  "Would you ever knowingly enter into an open relationship? What rules are required to keep the peace?",
];
